import { Fragment, useContext } from 'react'
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Inline,
  Heading,
  Visible,
  Hidden,
  Stack
} from '@leroy-merlin-br/backyard-react'
import { ChevronRight } from '@leroy-merlin-br/backyard-icons'

import { ShowMore } from 'shared/components/ShowMore'
import { Markdown } from 'shared/components/Markdown'

import { deliveryLimitHours } from 'site/utils/deliveryLimitHours'

import { EntryKeyContext } from '../../context/EntryKeyContext'
import { buildSearchMessage } from '../../utils/constants'
import * as S from './styled'

const TopContent = () => {
  const {
    pageInfo: { name, filterTitle, description, contents },
    searchType,
    isOnMobileApp,
    query: { term }
  } = useContext(EntryKeyContext)

  const dictionary = buildSearchMessage(searchType, term?.value)

  const freight = deliveryLimitHours()
  const isFastDelivery = filterTitle?.includes('Entrega Rápida')

  const renderContentList = () => {
    const MAX_CONTENTS = 9

    const slicedContents = contents.slice(0, MAX_CONTENTS)

    return (
      <Fragment>
        {slicedContents.map(content => (
          <Button
            key={content.id}
            as="a"
            href={content.url}
            variant="outline"
            iconRight={ChevronRight}>
            {content.title}
          </Button>
        ))}
      </Fragment>
    )
  }

  const renderContent = () => {
    if (searchType === 'error') {
      return <span>Realize uma nova busca.</span>
    }

    const topContentDescription = searchType
      ? `<h3>${dictionary.description}</h3>`
      : description

    return (
      <ShowMore scrollToParent showFloatButton>
        <S.Wrapper data-cy="top-content-description">
          <Markdown content={topContentDescription} />

          {!!contents.length && (
            <Stack space="mega">
              <Heading size="mega" as="h3" noMargin>
                Veja também essas dicas Leroy Merlin
              </Heading>

              <Row>
                <Col size={{ giga: 12 }}>
                  <S.ContentWrapper>
                    {!!contents.length && renderContentList()}
                  </S.ContentWrapper>
                </Col>
              </Row>
            </Stack>
          )}
        </S.Wrapper>
      </ShowMore>
    )
  }

  const renderTitle = size => (
    <Inline space="byte" alignX="flex-start">
      {searchType && dictionary.prefix && (
        <Heading size={size} as="h2" noMargin>
          {dictionary.prefix}
        </Heading>
      )}

      <Heading size={size} as="h1" noMargin>
        {searchType ? dictionary.term : name}{' '}
        {isFastDelivery
          ? `Com receba ${freight.deliveryForecast}`
          : filterTitle}
      </Heading>
    </Inline>
  )

  return (
    <Container data-cy="top-content">
      <S.CardWrapper>
        <Card>
          <S.TopContent type={searchType}>
            <Visible when={['kilo', 'untilKilo']}>
              {renderTitle('tera')}
            </Visible>

            <Hidden when={['kilo', 'untilKilo']}>{renderTitle('exa')}</Hidden>

            {!isOnMobileApp && description && renderContent()}
          </S.TopContent>
        </Card>
      </S.CardWrapper>
    </Container>
  )
}
export default TopContent
